import { Route } from '@angular/router';

export const ADMIN_PERMISSION_ROUTE_MAP: Record<string, string[]> = {
  AUDIT: ['audit'],
  DASHBOARD: ['dashboard'],
  CONNECTION: ['connection', 'admin-factory-tag'],
  DATA_EXPORT: ['data-export'],
  FILE_UPLOAD: ['file-upload'],
  USER_MANAGE: ['user-manage'],
  INVOICE_MANAGE: ['invoice-manage'],
  SCOPE_3_MANAGE: ['scope-3', 'source-scope-three'],
  CONVERSION_FACTOR: ['conversion-factor'],
  MODULE_AND_SOURCE: ['module-manage', 'source-manage'],
  ORGANIZATION_MANAGE: ['organization-manage'],
  UNIT_AND_DEPARTMENT: ['type-and-department'],
  CHEMICAL_MANAGEMENT_MODULE: ['chemical-management'],
  WASTE_MANAGEMENT_MODULE: ['waste-management'],
  SUBSCRIPTION_PLAN_AND_FEATURES: ['subscription-plan', 'feature']
};

export function getAllowedAdminRoutes(permissionKey: string, adminRoutes: string[] = []): string[] {
  if (!permissionKey) return [];

  const mappedRoutes = ADMIN_PERMISSION_ROUTE_MAP[permissionKey] || [];

  if (mappedRoutes.length) {
    return mappedRoutes.filter(route => adminRoutes.length === 0 || adminRoutes.includes(route));
  }

  const normalizedRoute = permissionKey.toLowerCase().replace(/_/g, '-');
  return adminRoutes.includes(normalizedRoute) ? [normalizedRoute] : [];
}

export function getAdminRoutePaths(routes: Route[]): string[] {
  const layoutRoute = routes.find(route => route.path === '' && Array.isArray(route.children));
  return (layoutRoute?.children || [])
    .map(route => route.path)
    .filter((path): path is string => !!path && path !== '**');
}

export function isAdminRouteAllowed(
  urlOrLink: string | undefined,
  allowedRoutes: string[]
): boolean {
  if (!urlOrLink) return false;

  const currentPath = urlOrLink.split('?')[0].replace(/^\/+/, '').split('/')[0];
  return allowedRoutes.includes(currentPath);
}
